import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './MainSection.scss'


const MainSection = ({ children, className, id, alignCenter, withPaddingTop, withPaddingBottom }) => {
  const rootClassName = cx(s.container, className, {
    [s.alignCenter]: alignCenter,
    [s.paddingTop]: withPaddingTop,
    [s.paddingBottom]: withPaddingBottom,
  })

  return (
    <div className={rootClassName} id={id}>
      {children}
    </div>
  )
}

MainSection.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  alignCenter: PropTypes.bool,
  withPaddingTop: PropTypes.bool,
  withPaddingBottom: PropTypes.bool,
}

MainSection.defaultProps = {
  withPaddingTop: true,
  withPaddingBottom: true,
}


export default MainSection
